var FreeBetsStatus;
(function (FreeBetsStatus) {
    FreeBetsStatus[FreeBetsStatus["Unknown"] = 0] = "Unknown";
    FreeBetsStatus[FreeBetsStatus["Pending"] = 1] = "Pending";
    FreeBetsStatus[FreeBetsStatus["Accepted"] = 2] = "Accepted";
    FreeBetsStatus[FreeBetsStatus["Finished"] = 3] = "Finished";
    FreeBetsStatus[FreeBetsStatus["Expired"] = 4] = "Expired";
    FreeBetsStatus[FreeBetsStatus["Canceled"] = 5] = "Canceled";
    FreeBetsStatus[FreeBetsStatus["Failed"] = 6] = "Failed";
})(FreeBetsStatus || (FreeBetsStatus = {}));

export { FreeBetsStatus };
